import script from "./base-global-event-listeners.vue?vue&type=script&lang=ts"
export * from "./base-global-event-listeners.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__